<template>
  <div class="form-wrapper">
    <router-link :to="{ name: 'game-login' }">
      <img class="logo" src="/images/logo-font-white.svg" alt="Logo yuzu" />
    </router-link>
    <div class="block">
      <h2>Bienvenue chez Yuzu</h2>
      <p>
        <span class="primary-color bold">{{
          invitation?.campaign?.public_name
        }}</span
        > vous a invité à rejoindre sa campagne Yuzu. Pour accéder à votre aventure et découvrir vos soft skills, veuillez compléter le formulaire ci-dessous.
      </p>
    </div>
    <VForm
      :button="{
        label: 'S\'inscrire',
        class: 'primary full-size',
        hotDisabled: true,
        style: state.validForm ? getThemeStyle(invitation?.campaign) :  '' ,
      }"
      :externalRule="(state.optin == true)"
      @validForm="validateForm"
      :callback="submitForm"
    >
      <template #form-body="{ errors }">
        <div class="input-inline">
          <VField
            :label="$t('form.register.firstName')"
            placeholder="Denis"
            name="firstname"
            rules="required|textOnly|max:50"
            v-model="candidateStore.joinInformations.first_name"
            icon="bi-person-vcard"
            :class="{ invalid: Object.keys(errors)[0] === 'firstname' }"
          />
          <VField
            :label="$t('form.register.lastName')"
            placeholder="Maurice"
            name="lastname"
            rules="required|textOnly|max:50"
            v-model="candidateStore.joinInformations.last_name"
            icon="bi-person-vcard"
            :class="{ invalid: Object.keys(errors)[0] === 'lastname' }"
          />
        </div>
        <VField
          label="Email"
          type="email"
          placeholder="adresse@email.com"
          name="email"
          rules="required||email|max:100"
          v-model="candidateStore.joinInformations.email"
          icon="bi-at"
          :disabled="candidateStore.invitation.email !== ''"
          :class="{ invalid: Object.keys(errors)[0] === 'email' }"
        />
        <div class="input-inline">
          <VField
            type="password"
            label="Mot de passe"
            placeholder="••••••••••••"
            name="password"
            rules="required|password"
            v-model="candidateStore.joinInformations.password"
            icon="bi-lock"
            :class="{ invalid: Object.keys(errors)[0] === 'password' }"
          />
          <VField
            :label="$t('form.register.confirmPassword')"
            type="password"
            placeholder="••••••••••••"
            name="confirmPassword"
            icon="bi-lock"
            rules="required|match:@password"
            :class="{ invalid: Object.keys(errors)[0] === 'confirmPassword' }"
          />
        </div>
        <div class="addons">
          <div class="checkbox-group">
            <input
              type="checkbox"
              id="remember"
              name="remember"
              v-model="state.optin"
            />
            <label for="remember"
              >J'ai lu et j'accepte les
              <a href="https://yuzu.hr/legal/cgu.pdf" target="_blank"
                >Conditions de service</a
              >
              et la
              <a href="https://yuzu.hr/legal/privacy.pdf" target="_blank"
                >Politique de confidentialité</a
              >
              de Yuzu.</label
            >
          </div>
        </div>
      </template>
    </VForm>
  </div>
</template>

<script setup>
import { reactive, computed } from "vue";
import { useCandidateStore } from "@/stores/candidate.js";
import { useToast } from "vue-toastification";
import { getError } from "@/composables/error.js";
import { storeToRefs } from "pinia";

const emits = defineEmits(["next"]);

const toast = useToast();

const candidateStore = useCandidateStore();

const { invitation } = storeToRefs(candidateStore);

const state = reactive({
  optin: false,
  validForm:  false,
});

async function submitForm() {
  if (!state.optin) {
    toast.error(getError("ERROR_OPTIN_REQUIRED"));
    return;
  }

  emits("next");
}

function validateForm(isValid) {
  state.validForm = isValid;
}

function getThemeStyle (campaign) {
  if(!campaign) {
    return '';
  }

  var bgColour = "#f2cb36";
  var textColour = "#000000";

  return {
  'background-color': campaign.elem_colour ? campaign.elem_colour+"!important" : bgColour,
  'color': campaign.text_colour ? campaign.text_colour+"!important" : textColour,
  };
}
</script>
